angular.module('app').component('owGeneral', {
    templateUrl: 'js/components/ow-general/index.html?cache=1',
    require: {
        $ow: '^^objectWindow',
    },
    controller: OWGeneralController,
    controllerAs: '$og',
    bindings: {
        object: '<',
    },
});

OWGeneralController.$inject = ['$window'];

function OWGeneralController($window) {
    var $ctrl = this;

    $ctrl.expands = {
        address: false,
    };

    $ctrl.toggleExpand = function(key) {
        $ctrl.expands[key] = !$ctrl.expands[key];
        $ctrl.$ow.api.on.resize();
    };

    /**
     * Open object location in Google Maps
     *
     * @param {object} object vehicle
     *
     * @returns {void}
     */
    $ctrl.openInGoogleMaps = function(object) {
        var url = 'https://maps.google.com/maps?q=' + object.last.y + '+' + object.last.x;

        $window.open(url, 'google');
        return true;
    };

    $ctrl.$onInit = function() {
        $ctrl.$ow.childs.push(this);
    };

    $ctrl.onObjectChanged = function() {};
}
